import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';

import LayoutSlice from '~/common/stores/layout.slice.ts';
import AdminSlice from '~/features/admin/stores/admin.slice.ts';
import AuthSlice from '~/features/auth/stores/auth.slice.ts';
import CatalogSlice from '~/features/catalog/stores/catalog.slice.ts';
import MatchingSlice from '~/features/matching/stores/matching.slice.ts';
import PaymentSlice from '~/features/payment/stores/payment.slice.ts';
import ProfileSlice from '~/features/profile/stores/profile.slice.ts';
import ReviewSlice from '~/features/review/stores/review.slice.ts';
import TutorSlice from '~/features/tutor/stores/tutor.slice.ts';

import type { TypedUseSelectorHook } from 'react-redux';

const ACTION_STORE_CLEAR = { type: 'root/STORE_CLEAR' } as const;

const combined = combineReducers({
  layout: LayoutSlice.reducer,
  admin: AdminSlice.reducer,
  auth: AuthSlice.reducer,
  catalog: CatalogSlice.reducer,
  matching: MatchingSlice.reducer,
  payment: PaymentSlice.reducer,
  profile: ProfileSlice.reducer,
  review: ReviewSlice.reducer,
  tutor: TutorSlice.reducer,
});

const rootReducer: typeof combined = (state, action) => {
  switch (action.type) {
    case ACTION_STORE_CLEAR.type:
      return combined(undefined, action);

    default:
      return combined(state, action);
  }
};

export const store = configureStore({
  devTools: process.env.NODE_ENV === 'development',
  middleware: getDefaultMiddleware => getDefaultMiddleware({ serializableCheck: false }),
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
